// @flow
import React from "react";
import withStyles from "elevate-ui/withStyles";
import Typography from "elevate-ui/Typography";
import Hr from "elevate-ui/Hr";
import { withGlobalContext } from "../common/GlobalContext";

import type { $Agent, $Site, $SiteOffice } from "flow/types";

type $Props = {
  classes: Object,
  agent: $Agent,
  office: $SiteOffice,
  site: $Site,
};

const Agentology = ({ agent, office, classes, site }: $Props) => {
  const ownerName = agent
    ? `${agent.firstName} ${agent.lastName}`
    : office
      ? office.name
      : "";
  const domainLabel =
    site.primaryDomain && site.primaryDomain.label
      ? site.primaryDomain.label
      : site.primaryDomain && site.primaryDomain.domain
        ? site.primaryDomain.domain
        : "";
  return (
    <div className={classes.root}>
      <Typography type="heading2" gutterTop gutterBottom>
        Terms of Use
      </Typography>
      <Hr />
      <Typography type="body" gutterBottom gutterTop>
        {ownerName} WELCOMES YOU TO {domainLabel}! WE ASK THAT YOU READ THE
        FOLLOWING TERMS OF USE, WHICH CONSTITUTE A LICENSE THAT COVERS YOUR USE
        OF THIS SITE AND ANY TRANSACTIONS THAT YOU ENGAGE IN THROUGH THIS SITE
        (AGREEMENT). BY ACCESSING, VIEWING, OR USING THIS SITE, YOU ACKNOWLEDGE
        THAT YOU HAVE READ, UNDERSTAND, AND AGREE WITH THESE TERMS. IF YOU DO
        NOT WISH TO BE BOUND BY THESE TERMS, PLEASE DO NOT USE THIS SITE.
      </Typography>
      <Typography type="heading5" gutterBottom gutterTop>
        USE OF SITE
      </Typography>
      <Typography type="body" gutterBottom gutterTop>
        This website is provided solely for the use of current and future
        clients of {ownerName} and their Associates to provide you with
        information about our company, to review our services, and to enable you
        to contact us with any questions or comments that you may have. Any
        other use of this site is prohibited. By way of example, you should not
        use any features of this site that permit communications or postings to
        post, transmit, display, or otherwise communicate
      </Typography>
      <Typography type="body" gutterBottom gutterTop>
        i. any defamatory, threatening, obscene, harassing, or otherwise
        unlawful information;
      </Typography>
      <Typography type="body" gutterBottom gutterTop>
        ii. any advertisement, solicitation, spam, chain letter, or other
        similar type of information;
      </Typography>
      <Typography type="body" gutterBottom gutterTop>
        iii. any encouragement of illegal activity;
      </Typography>
      <Typography type="body" gutterBottom gutterTop>
        iv. unauthorized use or disclosure of private, identifiable information
        of others; or
      </Typography>
      <Typography type="body" gutterBottom gutterTop>
        v. any materials subject to trademark, copyright, or other laws
        protecting any materials or data of others in the absence of a valid
        license or other right to do so.
      </Typography>
      <Typography type="heading5" gutterBottom gutterTop>
        SITE CONTENTS AND OWNERSHIP
      </Typography>
      <Typography type="body" gutterBottom gutterTop>
        The information contained on this site, including all images, designs,
        photographs, writings, graphs, data, and other materials (Materials) are
        the property of {domainLabel}, and are licensed to {ownerName}. The
        Materials are protected by copyrights, trademarks, trade secrets, or
        other proprietary rights. Permission is granted to display, copy,
        distribute, download, and print portions of this site solely for the
        purposes of using this site for the authorized uses described above. You
        must retain all copyright and other proprietary notices on all copies of
        the Contents. You shall comply with all copyright laws worldwide in your
        use of this Web site and prevent unauthorized copying of the Contents.
        Except as provided in this Notice, {domainLabel} and {ownerName}, do not
        grant you any express or implied rights in or under any patents,
        trademarks, copyrights, or trade secret information.
      </Typography>
      <Typography type="heading5" gutterBottom gutterTop>
        DISCLAIMER OF WARRANTY
      </Typography>
      <Typography type="body" gutterBottom gutterTop>
        You expressly agree that use of this Web site is at your sole risk.
        Neither {domainLabel}, {ownerName}, or their affiliates, nor any of
        their officers, directors, employees, agents, third-party content
        providers, or licensors (collectively, “Providers”), or the like,
        warrant that this site will be uninterrupted or error-free; nor do they
        make any warranty as to the results that may be obtained from the use of
        this site, or as to the accuracy, completeness, reliability, security,
        or currency of the Materials.
      </Typography>
      <Typography type="body" gutterBottom gutterTop>
        The Materials may contain errors, omissions, inaccuracies, or outdated
        information. Further, {domainLabel} and {ownerName}, do not warrant
        reliability of any statement or other information displayed or
        distributed through the site. {domainLabel} and {ownerName}, reserve
        their right, in their sole discretion, to correct any errors or
        omissions in any portion of the site. {domainLabel} and {ownerName}, may
        make any other changes to this site, the Materials and the products,
        programs, services, or prices (if any) described in this site at any
        time without notice.
      </Typography>
      <Typography type="body" gutterBottom gutterTop>
        THIS SITE AND THE INFORMATION, CONTENT, AND MATERIALS ON THIS SITE ARE
        PROVIDED ON AN “AS IS,”“WHERE IS,” AND “WHERE AVAILABLE” BASIS.{" "}
        {domainLabel} AND {ownerName}, MAKE NO REPRESENTATIONS OR WARRANTIES OF
        ANY KIND, EXPRESS OR IMPLIED, AS TO THE OPERATION OF THE SITE, THE
        CONTENT, INFORMATION, OR THE MATERIALS ON THIS SITE. TO THE FULLEST
        EXTENT PERMISSIBLE UNDER APPLICABLE LAW, {domainLabel} AND {ownerName},
        EXPRESSLY DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, OF ANY KIND,
        WITH RESPECT TO ANY OF THE MATERIALS, CONTENT, OR INFORMATION ON THIS
        SITE OR ANY GOODS OR OTHER PRODUCTS OR SERVICES OFFERED, SOLD, OR
        DISPLAYED ON THIS SITE OR YOUR USE OF THIS SITE GENERALLY, INCLUDING
        WARRANTIES OF MERCHANTABILITY, ACCURACY OF INFORMATION, QUALITY, TITLE,
        FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. SOME
        JURISDICTIONS LIMIT OR DO NOT ALLOW THE DISCLAIMER OF IMPLIED OR OTHER
        WARRANTIES, SO THE ABOVE DISCLAIMER MAY NOT APPLY TO THE EXTENT SUCH
        JURISDICTION’S LAW APPLIES TO THIS AGREEMENT.
      </Typography>
      <Typography type="heading5" gutterBottom gutterTop>
        LIMITATION OF LIABILITIES
      </Typography>
      <Typography type="body" gutterBottom gutterTop>
        YOU AGREE THAT {domainLabel} AND {ownerName}, AND THEIR PROVIDERS SHALL
        NOT BE LIABLE FOR ANY DAMAGE, LOSS, OR EXPENSE OF ANY KIND ARISING OUT
        OF OR RESULTING FROM YOUR POSSESSION OR USE OF THE MATERIALS, CONTENT,
        OR INFORMATION ON THIS SITE REGARDLESS OF WHETHER SUCH LIABILITY IS
        BASED IN TORT, CONTRACT, OR OTHERWISE. IN NO EVENT, INCLUDING, WITHOUT
        LIMITATION, A NEGLIGENT ACT, SHALL {domainLabel}, {ownerName}, OR ANY OF
        THEIR PROVIDERS BE LIABLE TO YOU FOR ANY DIRECT, INDIRECT, SPECIAL,
        INCIDENTAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES (INCLUDING, WITHOUT
        LIMITATION, LOSS OF PROFITS, LOSS OR CORRUPTION OF DATA, LOSS OF
        GOODWILL, WORK STOPPAGE, comPUTER FAILURE OR MALFUNCTION, OR
        INTERRUPTION OF BUSINESS), ARISING OUT OF OR IN ANY WAY RELATED TO THE
        MATERIALS, CONTENT, OR INFORMATION ON THIS SITE OR ANY OTHER PRODUCTS,
        SERVICES, OR INFORMATION OFFERED, SOLD, OR DISPLAYED ON THIS SITE, YOUR
        USE OF, OR INABILITY TO USE, THIS SITE GENERALLY, OR OTHERWISE IN
        CONNECTION WITH THIS AGREEMENT, REGARDLESS OF WHETHER {domainLabel},{" "}
        {ownerName}, OR ANY OF ITS PROVIDERS HAVE BEEN ADVISED OF THE
        POSSIBILITY OF SUCH DAMAGES. BECAUSE SOME STATES DO NOT ALLOW THE
        LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES, THE
        ABOVE LIMITATION MAY NOT APPLY TO YOU.
      </Typography>
      <Typography type="heading5" gutterBottom gutterTop>
        INDEMNIFICATION
      </Typography>
      <Typography type="body" gutterBottom gutterTop>
        You agree to indemnify, defend, and hold harmless {ownerName}, its
        affiliates, agents, employees, and licensors from and against any and
        all claims and expenses, including reasonable attorney fees, arising out
        of or related in any way to your use of the site, violation of this
        Agreement, violation of any law or regulation, or violation of any
        proprietary or privacy right.
      </Typography>
      <Typography type="heading5" gutterBottom gutterTop>
        PRIVACY POLICY
      </Typography>
      <Typography type="body" gutterBottom gutterTop>
        Click here to access the Privacy Policy of {ownerName}, which governs
        the use of information that {ownerName}, obtains from you through your
        use of this Web site.
      </Typography>
      <Typography type="heading5" gutterBottom gutterTop>
        LIMITATIONS ON CLAIM
      </Typography>
      <Typography type="body" gutterBottom gutterTop>
        Any cause of action you may have with respect to your use of this site
        must be commenced within one year after the claim or cause of action
        arises.
      </Typography>
      <Typography type="heading5" gutterBottom gutterTop>
        TERM AND TERMINATION
      </Typography>
      <Typography type="body" gutterBottom gutterTop>
        Without limiting its other remedies, {domainLabel} or {ownerName}, may
        immediately discontinue, suspend, terminate, or block your and any
        user’s access to this site at any time in our sole discretion.
      </Typography>
      <Typography type="heading5" gutterBottom gutterTop>
        HYPERLINK DISCLAIMERS
      </Typography>
      <Typography type="body" gutterBottom gutterTop>
        As a convenience to you, we may provide on this site links to Web sites
        operated by other entities (collectively the “Linked Sites”). If you use
        any Linked Sites, you will leave this site. If you decide to visit any
        Linked Site, you do so at your own risk and it is your responsibility to
        take all protective measures to guard against viruses or other
        destructive elements. Linked Sites, regardless of the linking form
        (e.g., hotlinks, hypertext links, IMG links) are not maintained,
        controlled, or otherwise governed by {domainLabel} or {ownerName}. The
        content, accuracy, opinions expressed, and other links provided by
        Linked Sites are not investigated, verified, monitored, or endorsed by{" "}
        {domainLabel} or {ownerName}. {domainLabel} and {ownerName}, does not
        endorse, make any representations regarding, or warrant any information,
        goods, and/or services appearing and/or offered on any Linked Site,
        other than linked information authored by {domainLabel} or {ownerName}.
        Links do not imply that {domainLabel}, {ownerName}, or this site
        sponsors, endorses, is affiliated or associated with, or is legally
        authorized to use any trademark, trade name, logo, or copyright symbol
        displayed in or accessible through the links, or that any Linked Site is
        authorized to use any trademark, trade name, logo or copyright symbol of{" "}
        {domainLabel}, {ownerName}, or any of its affiliates or subsidiaries.
        Except for links to information authored by {domainLabel} or {ownerName}
        , neither
        {domainLabel} nor {ownerName}, are responsible for, nor will either be
        liable under any theory based on (i) any Linked Site; (ii) any
        information and/or content found on any Linked Site; or (iii) any
        site(s) linked to or from any Linked Site. If you decide to visit any
        Linked Sites and/or transact any business on them, you do so at your own
        risk. {domainLabel} and {ownerName}, reserve the rights to discontinue
        any Linked Site at any time without prior notice. Please contact the Web
        masters of any Linked Sites concerning any information, goods, and/or
        services appearing on them.
      </Typography>
      <Typography type="heading5" gutterBottom gutterTop>
        CONTROLLING LAW, JURISDICTION, AND INTERNATIONAL USERS
      </Typography>
      <Typography type="body" gutterBottom gutterTop>
        This Agreement is governed by and shall be construed in accordance with
        the laws of the State of Michigan, U.S.A., without reference to its
        conflict-of-law provisions. {domainLabel} and {ownerName}, make no
        representation that the materials are appropriate or available for use
        outside the United States. If you access this site from outside the
        United States, you will be responsible for compliance with all local
        laws. You agree to comply with all laws and regulations applicable to
        your use of this site. You agree to submit to the personal and exclusive
        jurisdiction of the state or federal courts located within Washtenaw
        County, Michigan for any disputes with {domainLabel} and {ownerName},
        arising out of your use of this site.
      </Typography>
      <Typography type="heading5" gutterBottom gutterTop>
        ENTIRE AGREEMENT
      </Typography>
      <Typography type="body" gutterBottom gutterTop>
        This Agreement constitutes the entire agreement between {domainLabel},
        {ownerName}, and you with respect to this Web site, and it supersedes
        all prior or contemporaneous communications and proposals, whether
        electronic, oral, or written, between you, {domainLabel} and {ownerName}
        , with respect to this Web site. A printed version of this Agreement and
        of any notice given in electronic form shall be admissible in judicial
        or administrative proceedings based on or relating to this Agreement to
        the same extent and subject to the same conditions as other business
        documents and records originally generated and maintained in printed
        form. If for any reason a court of competent jurisdiction finds any
        provision of this Agreement or portion of it to be unenforceable, that
        provision shall be enforced to the maximum extent permissible so as to
        effect the intent of this Agreement, and the remainder of this Agreement
        shall continue in full force and effect. No waiver by either party of
        any breach or default hereunder shall be deemed to be a waiver of any
        preceding or subsequent breach or default.
      </Typography>
      <Typography type="heading5" gutterBottom gutterTop>
        MODIFICATIONS TO AGREEMENT
      </Typography>
      <Typography type="body" gutterBottom gutterTop>
        This Agreement may be revised at any time and you agree to be bound by
        the revised Agreement. Any such modifications will become effective on
        the date they are first posted to this site. It is your responsibility
        to return to this Agreement from time-to-time to review the most current
        terms and conditions. {domainLabel} and {ownerName}, do not and will not
        assume any obligation to notify you of changes to this Agreement.
      </Typography>
      <Typography type="heading5" gutterBottom gutterTop>
        ELECTRONIC COMMUNICATIONS AND ELECTRONIC SIGNATURES
      </Typography>
      <Typography type="body" gutterBottom gutterTop>
        You agree to be bound by any affirmation, assent, or agreement you
        transmit through this Web site, including, but not limited to, any
        consent you give to receive communications from {domainLabel} and{" "}
        {ownerName}, solely through electronic transmission. You agree that when
        in the future you click on an “I agree,” “I consent,” or other similarly
        worded “button” or entry field with your mouse, keystroke, or other
        computer device, your agreement or consent will be legally binding and
        enforceable and the legal equivalent of your handwritten signature.
      </Typography>
      <Typography type="heading5" gutterBottom gutterTop>
        EQUAL HOUSING
      </Typography>
      <Typography type="body" gutterBottom gutterTop>
        We are pledged to the letter and spirit of U.S. policy for the
        achievement of equal housing opportunity throughout the nation. We
        encourage and support an affirmative advertising and marketing program
        in which there are no barriers to obtaining housing because of race,
        color, religion, sex, handicap, familial status or national origin.
      </Typography>
    </div>
  );
};

const styles = () => ({
  root: {
    position: "relative",
    width: "100%",
    maxWidth: "970px",
    margin: "40px auto",
    "& p": {
      maxWidth: "100%",
    },
    "& strong": {
      fontWeight: "bold",
    },
  },
});

export default withGlobalContext(withStyles(styles)(Agentology));
